GP.views.ThreadMiniProfile = Backbone.Marionette.ItemView.extend({
    template: function(serialized_data) {
        return template('thread-mini-profile', serialized_data);
    },
    className: 'mini-profile-wrap',
    ui: {
        unread_count: '.unread-count',
        sent_via_web: '.sent-via.web',
        sent_via_mobile: '.sent-via.mobile',
        sent_via_wywa: '.sent-via.wywa',
        sent_via_mpf: '.sent-via.mpf',
        sent_via_ice_breaker: '.sent-via.ice-breaker',
        vc_request_private: '.vc-request-private',
    },
    initialize:function(opts) {
        this.listenTo(this.model, 'change', this.model_changed);
        this.listenTo(GP.vent, 'ThreadMiniProfile.'+this.options.thread_id+':increment_unread_count', this.increment_unread_count, this);
        this.listenTo(GP.vent, 'ThreadMiniProfile.'+this.options.thread_id+':hide_unread_count', this.hide_unread_count, this);
        this.listenTo(GP.vent, 'ThreadMiniProfile.'+this.options.thread_id+':show_sent_via', this.show_sent_via, this);
        this.listenTo(GP.vent, 'ThreadMiniProfile.'+this.options.thread_id+':hide_private_popover', this.hide_private_popover, this);
        this.listenTo(GP.vent, 'ThreadMiniProfile.'+this.options.thread_id+':handle_premium_attachment_purchase', this.handle_premium_attachment_purchase, this);
    },
    templateHelpers: {
        user_online: function() {
            return (this.online_status == 'ONLINE') ? '' : 'hide';
        },
        location_string: function() {
            if (this.country_code == 'US') {
               return this.city+' '+this.state_code+', '+this.country_code;
            } else {
                return this.city+', '+this.country_code;
            }
        },
        gender_string: function() {
            return (this.gender_detail) ? this.gender_detail : this.gender;
        },
        add_friend: function() {
            return (this.friend) ? 'hide' : '';
        },
        add_favorite: function() {
            return (this.favorite) ? 'hide' : '';
        },
        grant_private: function() {
            return (!this.show_private_approval_options || this.has_access_private) ? 'hide' : '';
        },
        remove_friend: function() {
            return (!this.friend) ? 'hide' : '';
        },
        remove_favorite: function() {
            return (!this.favorite) ? 'hide' : '';
        },
        revoke_private: function() {
            return (!this.show_private_approval_options || !this.has_access_private) ? 'hide' : '';
        },
        show_restricted_section: function() {
            return (this.duid == 69) ? false : true;
        },
        show_private_vc: function() {
            // return (window._vc_beta && this.online_status == 'ONLINE') ? true : false;
            if (this.duid != 69 && this.duid != 80918084) {
                return (window._vc_beta) ? true : false;
            }
            return false;
        },
        show_mini_thumbs: function() {
            return (this.duid != 69 && (this.pics.length > 1));
        },
        show_info: function() {
            return (this.duid != 69 && !_ai_chatbot_duids.includes(parseInt(this.duid)));
        },
        show_date_lab_badge: function() {
            return _feedback_user_duids.includes(parseInt(this.duid));
        },
        show_ai_badge: function() {
            return _ai_chatbot_duids.includes(parseInt(this.duid));
        },
        is_ai_chatbot: function() {
            return _ai_chatbot_duids.includes(parseInt(this.duid,10));
        }
    },
    onRender: function() {
        if (GP.sdata.my_user.membership == 'FREE') {
            this.$el.addClass('free');
        }

        var $profile_pic = this.$el.find('.profile-pic img');
        var s_profile_pic = $profile_pic.attr('src').replace('-M.jpg', '-S.jpg');
        $profile_pic.attr('src', s_profile_pic);

        this.$el.find('.mini-pic').each(function() {
            var src = $(this).attr('src').replace('.mp4', '-S.jpg');
            $(this).attr('src', src);
        });

        // NOTE: disable on mobile due to styling issues with the popover when opened from pics near the edge of the screen
        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
            this.$el.find('.mini-pic').popover({
                html: true,
                trigger: 'hover',
                placement: 'bottom',
                container: '#message-thread-img-preview',
                sanitize: false,
                content: function() {
                    if (GP.sdata.my_user.membership != 'FREE') {
                        if ($(this).attr('src').match(/discreet/)) {
                            return;
                        }

                        var replacement_image = $(this).attr('src').replace(/-S.jpg|.mp4/g, '-L.jpg');
                        if (/media/.test(replacement_image)) {
                            replacement_image = replacement_image.replace('-M.jpg', '-L.jpg');
                        }
                        return '<img src="'+replacement_image+'" />';
                    } else {
                        return js_lang.upgrade_pics;
                    }
                }
            });
        }
    },
    events: {
        'click .close' : 'close',
        'click div.dock' : 'minimize',
        'click .js-dock' : 'minimize',
        'click div.maximize' : 'maximize',
        'click div.minimize' : 'full_minimize',
        'click .js-minimize' : 'full_minimize',
        'click .js-maximize' : 'maximize',
        'click .mini-profile-top.minimized' : 'maximize',
        'click .add-friend' : 'add_friend',
        'click .add-favorite' : 'add_favorite',
        'click .grant-private' : 'grant_private',
        'click .remove-friend' : 'remove_friend',
        'click .remove-favorite' : 'remove_favorite',
        'click .revoke-private' : 'revoke_private',
        'click .block' : 'block',
        'click .vc-request-private' : 'vc_request_private',
        'click .btn-msg-options' : 'handle_options_dropdown',
    },
    model_changed: function() {
        this.render();
        var thread_id = this.options.thread_id;
        GP.vent.trigger('MessagePane.Thread:set_mini_profile_sent_via', { thread_id : thread_id });
    },
    increment_unread_count: function() {
        if (this.$el.closest('.message-thread').hasClass('docked') || this.$el.closest('.message-thread').hasClass('minimized')) {
            var cur_count = parseInt(this.ui.unread_count.text(),10) | 0;
            this.ui.unread_count.text(cur_count+1).show();
        }
    },
    hide_unread_count: function() {
        this.ui.unread_count.text('').hide();
    },
    show_sent_via: function(obj) {
        if (obj.sent_via == 'wywa') {
            this.$el.find('.sent-via.wywa span').popover({
                html: true,
                trigger: 'click hover',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.wywa_explanation;
                }
            });
            this.$el.find('.sent-via.wywa').show();
            // this.ui.sent_via_wywa.show();
        } else if (obj.sent_via == 'mpf') {
            this.$el.find('.sent-via.mpf span').popover({
                html: true,
                trigger: 'click hover',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.mpf_explanation;
                }
            });
            this.$el.find('.sent-via.mpf').show();
            // this.ui.sent_via_mpf.show();
        } else if (obj.sent_via == 'mobile') {
            this.$el.find('.sent-via.mobile').show();
            // this.ui.sent_via_mobile.show();
        } else if (obj.sent_via == 'web') {
            this.$el.find('.sent-via.web').show();
            // this.ui.sent_via_web.show();
        } else if (obj.sent_via == 'ice_breaker') {
            this.$el.find('.sent-via.ice-breaker span').popover({
                html: true,
                trigger: 'click hover',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.ice_breaker_explanation;
                }
            });
            this.$el.find('.sent-via.ice-breaker').show();
            // this.ui.sent_via_ice_breaker.show();
        }
    },
    handle_premium_attachment_purchase: function() {
    },
    close: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':close');
    },
    maximize: function(e) {
        // when the thread is minimized any click on the mini-profile should maximize it (except a click on close)
        if (e && !$(e.target).hasClass('close')) {
            // we don't want to navigate to the profile
            e.preventDefault();
            e.stopPropagation();
            GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':maximize');
        } else if (e && $(e.target).hasClass('maximize'))  {
            GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':maximize');
        }
        this.$el.find('.options-wrap').removeClass('dropup');
    },
    minimize: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':minimize');
        this.$el.find('.options-wrap').removeClass('dropup');
    },
    full_minimize: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':minimize', { full_minimize: true });
    },
    add_friend: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':add_friend');
    },
    add_favorite: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':add_favorite');
    },
    grant_private: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':grant_private');
    },
    remove_friend: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':remove_friend');
    },
    remove_favorite: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':remove_favorite');
    },
    revoke_private: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':revoke_private');
    },
    block: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':block');
    },
    vc_request_private: function() {
        // Submit a request to start a private 1-to-1 video chat with USERNAME?
        // blue "Send Request" button, red cancel link
        var thread_id = this.options.thread_id;
        var allow_private_vc = GP.sdata.MessagingThreads.get(thread_id).get('messages').allow_private_vc;
        var other_duid = GP.sdata.MessagingThreads.get(thread_id).get('other_duid');
        var other_username = GP.sdata.MessagingUsers.get(other_duid).get('username');


        var $vc_btn = this.$el.find('.vc-request-private');
        $vc_btn.popover({
            html: true,
            trigger: 'manual',
            // trigger: 'focus',
            // trigger: 'click',
            placement: 'bottom',
            sanitize: false,
            content: function() {
                var html = '';
                var evnt = ' data-event="ThreadLayout.thread-'+thread_id+':vc_request_private" ';
                var cancel_evnt = ' data-event="ThreadMiniProfile.'+thread_id+':hide_private_popover" ';

                if (allow_private_vc) {

                    html = '<div class="vc-request-popover"><p>Submit a request to start a private 1-to-1 video chat with <span class="username">' + other_username + '</span>?</p><p style="text-align:center"><button '+evnt+' class="btn btn-primary">Send Request</button> <a class="btn btn-default no-follow" href="#" '+cancel_evnt+'>cancel</a></p></div>';
                } else {
                    html = '<p style="width: 250px;">Video chat requests can only be sent to users on your friends list or members that replied to your messages</p><button type="button" '+cancel_evnt+' class="btn btn-primary btn-dismiss">Ok</button>';
                }
                return html;
            }
        });
        $vc_btn.popover('show');
    },
    hide_private_popover: function() {
        // this.ui.vc_request_private
        this.$el.find('.vc-request-private').popover('destroy');
    },
    handle_options_dropdown: function() {
        if (this.$el.closest('.message-thread').hasClass('minimized')) {
            this.$el.find('.options-wrap').addClass('dropup');
        }
    }
});

GP.views.MessagesListItem = Backbone.Marionette.ItemView.extend({
    initialize:function(opts) {
        this.listenTo(this.model, 'change', this.render);
    },
    template: function(serialized_data) {
        if (serialized_data.error) {
            return template('thread-message-error', serialized_data);
        } else if (serialized_data.msg_id == 1) {
            // rude user message (women only)
            return template('thread-message-rude-user', serialized_data);
        } else if (serialized_data.msg_id == 2) {
            // rude user warning (men only)
            return template('thread-message-rude-user-warning', serialized_data);
        } else if (serialized_data.msg_id == 3) {
            // sent message priority (set last sent message to priority after already sent)
            return template('thread-sent-message-priority', serialized_data);
        } else if (serialized_data.msg_id == 4) {
            // message read status
            return template('thread-message-read-status', serialized_data);
        } else if (serialized_data.msg_id == 5) {
            // message thread locked (exy logic)
            return template('thread-locked', serialized_data);
        } else if (serialized_data.msg_id == 6) {
            // bronze msg thread is able to claim credits
            return template('thread-message-bronze-claimable', serialized_data);
        } else if (serialized_data.msg_id == 7) {
            // bronze credits claimed
            return template('thread-message-bronze-claimed', serialized_data);
        } else if (serialized_data.msg_id == 12) {
            // ai chatbot notice
            return template('thread-message-ai-chatbot-notice', serialized_data);
        } else if (serialized_data.msg_id == 13) {
            // desktop load more messages spinner/button
            return template('thread-message-load-more', serialized_data);
        } else if (serialized_data.msg_id == 14) {
            // desktop load previous messages spinner/button
            return template('thread-message-load-previous', serialized_data);
        } else if (serialized_data.msg_system_id) {
            var id = parseInt(serialized_data.msg_system_id, 10);
            if ($.inArray(id, [643]) !== -1) {
                if (!serialized_data.private_approved) {
                    // private content system message for approve/deny request to view private content
                    return template('thread-message-private-content', serialized_data);
                }
            // private videochat request button
            } else if ($.inArray(id, [688]) !== -1) {
                // if (MoshPit.get_size() == 'mobile') {
                //     return template('thread-message-private-videochat', serialized_data);
                // } else {
                //     return template('thread-message', serialized_data);
                // }
                return template('thread-message-private-videochat', serialized_data);

            } else {
                return template('thread-message', serialized_data);
            }
        } else {
            return template('thread-message', serialized_data);
        }
    },
    serializeData: function() {
        // overwritten function for passing custom data to handlebars template
        var data = {};

        data = this.model.toJSON();

        var other_duid   = GP.sdata.MessagingThreads.get(this.options.thread_id).get('other_duid');
        var other_user   = GP.sdata.MessagingUsers.get(other_duid);
        var other_gender = other_user.get('gender');

        data.other_duid  = other_duid;
        data.thread_id   = this.options.thread_id;

        // if (this.model.get('msg_id') == 4) {
        if (data.msg_id == 4) {
            data.other_gender = other_gender.toLowerCase();
        }

        if (data.msg_id == 6) {
            var messages_collection = GP.sdata.MessagingThreads.get(this.options.thread_id).get('messages');

            data.claimable = messages_collection.claimable;
            data.claimed = messages_collection.claimed;
            data.claim_days_left = messages_collection.claim_days_left;
            data.claim_credit_amount = messages_collection.claim_credit_amount;
        }

        if (data.msg_id == 7) {
//             var mc = GP.sdata.MessagingThreads.get(this.options.thread_id).get('messages');
// console.warn('Thread serialized_data msg_id 7... data: ', data);
// console.warn('Thread serialized_data msg_id 7... mc: ', mc);

//             if (data.updated_credits) {
//             }
        }
        if (data.msg_id == 2) {
            var msg_approach_pref_key = other_user.get('msg_approach_pref');
            if (!(msg_approach_pref_key)) {
                msg_approach_pref_key = other_gender.toLowerCase() == 'man' ? 'SURPRISE' : 'POLITE';
            }

            var msg_interest_pref_hint = js_lang.msg_interest_pref_hint[other_gender.toLowerCase()];
            var interests = other_user.get('interests');

            var msg_approach_pref_hint = js_lang.msg_approach_pref_hint_short[other_gender.toLowerCase()];
            var msg_approach_pref = js_lang.msg_approach_pref[msg_approach_pref_key.toLowerCase()];

            data.other_username = other_user.get('username');
            data.msg_approach_pref_hint = msg_approach_pref_hint;
            data.msg_approach_pref = msg_approach_pref;
            data.msg_approach_pref_link = '/members/modal/message_hint_pref';
            data.msg_interest_pref_hint = msg_interest_pref_hint;
            data.interests = interests;
        }

        // Set the report url
        report_data = {
            reported_duid: GP.sdata.MessagingThreads.get(this.options.thread_id).get('other_duid'),
            reported_from: 'messaging',
            reload: 1,
        };
        data.report_url = GP.Util.clean_url('/members/user/report_user/', report_data);

        // console.log('Thread serializeData... data: ', data);
        return data;
    },
    templateHelpers: {
        msg_unread: function() {
            return (this.direction == 'sender' && this.other_unread === 1);
        },
        msg_read: function() {
            return (this.direction == 'sender' && this.other_unread === 0);
        },
        read_status_text_woman: function() {
            return (this.other_gender == 'woman');
        },
        read_status_text_man: function() {
            return (this.other_gender == 'man');
        },
        show_call_ended: function() {
            return (this.hasOwnProperty('call_ended') && this.call_ended === true);
        },
        user_has_rated: function() {
            return (this.hasOwnProperty('hon_voted') && this.hon_voted === true);
        },
        show_interests: function() {
            var other_duid   = GP.sdata.MessagingThreads.get(this.thread_id).get('other_duid');
            var other_user   = GP.sdata.MessagingUsers.get(other_duid);
            return other_user.get('interests') ? true : false;
        },
        days_left: function() {
            // console.log('templateHelpers days_left called... this: ', $.extend({}, this));

            var days = this.claim_days_left;

            if (days === 0) {
                return 'today';
            }
            return (days === 1) ? 'within ' + days + ' day' :  'within ' + days + ' days';
        },
        show_more_button: function() {
            let tags = this.tag || [];

            if (tags.includes('DELETED')) {
                return false;
            }

            // premium attachments that have been purchased are not allowed to be deleted.
            if ((tags.includes('PREMIUM_ATTACHMENT') || tags.includes('PREMIUM_VIDEO_ATTACHMENT'))
                && this.attachment_purchased
            ) {
                return false;
            }

            if (tags.includes('PRIORITY') || tags.includes('PRIORITY_GUARANTEE')) {
                return false;
            }

            return true;
        },
        show_reactions_button: function() {
            let tags = this.tag || [];

            if (tags.includes('DELETED')) {
                return false;
            }

            if (this.direction == 'sender' || this.is_site_master()) {
                return false;
            }

            return true;
        },
        is_site_master: function() {
            var other_duid   = GP.sdata.MessagingThreads.get(this.thread_id).get('other_duid');

            return (other_duid == 69) ? true : false;
        },
        is_profile_coach: function() {
            return _gp_profile_coach_duids.includes(parseInt(GP.sdata.MessagingThreads.get(this.thread_id).get('other_duid'), 10));
        },
        decode_all_entities: function(str) {
            // NOTE: this should ONLY be used for site-master or where we know the decoded content is safe
            var textarea = document.createElement("textarea");
            textarea.innerHTML = str;
            return textarea.value;
        }
    },
    tagName: 'li',
    className: '',
    ui: {
    },
    events: {
        'click .attachment' : 'zoom_attachment',
        'click .accept-attachments button' : 'accept_attachment',
        'click .message-text a' : 'handle_media_approved',
        // 'click .rude-no' : 'del_rude_user_msg',
        'click .rude-no' : 'rate_not_rude',
        'click .add-credits' : 'trigger_msg_priority',
        'click .sent-msg-priority' : 'trigger_sent_msg_priority',
        'click .private-content-yes' : 'approve_private_content',
        'click .private-content-no' : 'deny_private_content',
        'click .rate-user' : 'rate_user',
        'click .translate a' : 'translate_msg',
        'click .message-text': 'trigger_purchase',
        'click .btn-del-thread-msg' : 'handle_msg_options',
        'click .btn-reactions' : 'handle_reactions',
    },
    modelEvents: {
        "change:emoji" : "emoji_change"
    },
    translate_msg: function(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();

        let $element  = this.$el,
            thread_id = this.options.thread_id;

        $.post("/members/msg/translate_msg/", {
            'thread_id':       thread_id,
            'msg_text':        this.model.get('message'),
            'target_language': navigator.language
        }).done(function (json) {
            if (json && json.translated_text) {
                $element.find(".message-text").text(json.translated_text);
                $element.find(".translate").addClass("hide");
                return;
            }

            if (json && json.error) {
                let trigger_evnt = "ThreadLayout.thread-" + thread_id + ":show_notification";
                GP.vent.trigger(trigger_evnt, "danger", json.error);
                return;
            }
        }).always(function () {
            // do something here maybe?
        });
    },
    rate_not_rude: function(evnt) {
        var $clicked   = $(evnt.currentTarget);
        var thread_id  = this.options.thread_id;
        var other_duid = GP.sdata.MessagingThreads.get(thread_id).get('other_duid');
        var msg_model  = this.model;

        // TODO: where we want to save this?
        $.post('/members/msg/add_rating/', {
            'duid': other_duid,
            'score': 1 // 1 is nice, 0 is rude
        }).done(function(json) {
            // maybe do something different for success/fail?
        }).always(function() {
            $clicked.parent().text('Thank you!');

            setTimeout(function() {
                msg_model.destroy();
            }, 2000);
        });
    },
    onRender: function() {
        // console.log('Thread onRender... this: ', this);
        let $element  = this.$el;

        this.$el.attr('id', 'message_'+this.model.id);
        this.$el.find('.timeago').timeago();
        if (this.model.get('direction') == 'recipient') {
            this.$el.addClass('incoming');

            let tags         = this.model.get('tag') || [],
                exclude_tags = ['ATTACHMENT', 'AUDIO_ATTACHMENT', 'VIDEO_ATTACHMENT', 'VIDEO_ATTACHMENT_RDY','PREMIUM_ATTACHMENT', 'PREMIUM_VIDEO_ATTACHMENT'];

            let show_translate = this.model.get('show_translate_btn') ? true : false;
            if (show_translate && !tags.some(tag => exclude_tags.includes(tag))) {
                // console.warn('unhiding translate button...');
                $element.find('.message-meta .translate').removeClass('hide').show();
            }

            if (this.model.get('ai_chatbot') && this.model.get('modal_link')) {
                var highlight_text;
                if (this.model.get('modal_link').includes('billing')) {
                        highlight_text = 'must upgrade';
                    } else {
                        highlight_text = 'must verify';
                    }
                let $modal_link = $('<a/>')
                    .addClass('no-follow')
                    .attr('href', this.model.get('modal_link'))
                    .attr('data-event', 'Modal:open')
                    .attr('data-duid', this.model.get('sender_duid'))
                    .text(highlight_text);

                let $new_message = $('<span/>')
                    .html('You <span class="modal-link"></span> to see responses.');

                $new_message.find('.modal-link').html($modal_link);
                $element.find('.message-text').html($new_message);
            }

        } else {
            this.$el.addClass('outgoing');
        }

        if (this.model.get('msg_id') == 5) {
            this.$el.addClass('msg-thread-locked');
        }

        // if (this.model.get('msg_system_id') == 688 && MoshPit.get_size() == 'mobile') {
        if (this.model.get('msg_system_id') == 688) {
            this.$el.addClass('private-vc-system-msg');
        }
        if (_.contains(this.model.get('tag'), 'ATTACHMENT')) {
            this.handle_attachment();
        }
        if (_.contains(this.model.get('tag'), 'AUDIO_ATTACHMENT')) {
            this.handle_audio_attachment();
        }
        if (_.contains(this.model.get('tag'), 'VIDEO_ATTACHMENT_RDY')) {
            this.handle_video_attachment();
        } else if (_.contains(this.model.get('tag'), 'VIDEO_ATTACHMENT')) {
            this.handle_video_attachment_pending();
        }
        if (_.contains(this.model.get('tag'), 'PREMIUM_ATTACHMENT') || _.contains(this.model.get('tag'), 'PREMIUM_VIDEO_ATTACHMENT')) {
            this.handle_premium_attachment();
        }
        if (_.contains(this.model.get('tag'), 'PRIORITY')) {
            this.$el.addClass('priority');
        }
        if (_.contains(this.model.get('tag'), 'PRIORITY_GUARANTEE')) {
            this.$el.addClass('priority-guarantee');
        }
        if (_.contains(this.model.get('tag'), 'TIP')) {
            this.$el.addClass('tip');
        }
        if (_.contains(this.model.get('tag'), 'GT_PURCHASE')) {
            this.$el.addClass('gt-purchase');
        }
        if (GP.sdata.my_user.membership != 'FREE') {
            this.show_sent_via();
        }
        if (this.model.get('msg_id') == 3) {
            this.$el.addClass('sent-msg-priority clearfix');
        }
        if (this.model.get('msg_id') == 4) {
            this.$el.addClass('sent-msg-read-status');
        }
        if (this.model.get('msg_id') == 13) {
            this.$el.addClass('message-load-next-desktop');
        }
        if (this.model.get('msg_id') == 14) {
            this.$el.addClass('message-load-previous-desktop');
        }
        if (_.contains(this.model.get('tag'), 'DELETED')) {
            this.$el.addClass('msg-deleted');
        }
    },
    zoom_attachment: function(e) {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':zoom_attachment', e.currentTarget.src);
    },
    accept_attachment: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':accept_attachment');
    },
    handle_attachment: function() {
        var msg_body = '';
        if (this.model.get('attachment_status') == 'APPROVED' || this.model.get('direction') == 'sender') {
            var msg_id = this.model.get('msg_id');
            var attachment_id = 0;

            if (this.model.get('message')) {
                msg_body = '<br/>'+this.model.get('message');
            }
            if (msg_id < 6 * Math.pow(10,9)) {
                var self = this;
                $.post('/members/msg/get_message_attachment_id', { msg_id: msg_id }, function(data) {
                    attachment_id = data.attachment_id;
                });
            } else {
                attachment_id = msg_id;
            }

            // messages which are tagged ATTACHMENT should have an attachment_url generated server side now
            // but default to JS version of lib/util/api/msg.php:msg_attachment_url() function as a fallback
            var attachment_url = this.model.get('attachment_url');
            if (attachment_url) {
                msg_body = '<img class="attachment" src="'+attachment_url+'"/>'+msg_body;
            } else {
                msg_body = '<img class="attachment" src="'+this.get_attachment_url(attachment_id, this.model.get('sender_duid'))+'"/>'+msg_body;
            }
        } else {
            msg_body = '<p class="attachment-instructions">'+js_lang.attachment_instructions+'</p>';
            if (GP.sdata.my_user.gender == 'WOMAN') {
                msg_body += '<p class="attachment-warning">'+js_lang.attachment_warning+'</p>';
            }
            msg_body += '<div class="accept-attachments">'+
                            '<button class="btn btn-primary">'+js_lang.accept+'</button>'+
                        '</div>';
        }

        this.$el.find('.message-text').html(msg_body);
    },
    handle_video_attachment_pending: function() {
        var msg_body = '[Video upload is pending and will be available shortly.]';
        this.$el.find('.message-text').html(msg_body);
    },
    handle_video_attachment: function() {
        var msg_body = '';
        if (this.model.get('attachment_status') == 'APPROVED' || this.model.get('direction') == 'sender') {
            var msg_id = this.model.get('msg_id');
            var attachment_id = 0;

            if (this.model.get('message')) {
                msg_body = '<br/>'+this.model.get('message');
            }
            if (msg_id < 6 * Math.pow(10,9)) {
                var self = this;
                $.post('/members/msg/get_message_attachment_id', { msg_id: msg_id }, function(data) {
                    attachment_id = data.attachment_id;
                });
            } else {
                attachment_id = msg_id;
            }

            // messages which are tagged VIDEO_ATTACHMENT should have an get_video_attachment_url generated server side now
            // but default to JS version of lib/util/api/msg.php:get_video_attachment_url() function as a fallback
            var attachment_url = this.model.get('attachment_url');
            if (attachment_url) {
                msg_body = '<video class="video-attachment" controls preload="metadata"><source src="'+attachment_url+'#t=0.001" type="video/mp4"></video>'+msg_body;
            } else {
                msg_body = '<video class="video-attachment" controls preload="metadata"><source src="'+this.get_video_attachment_url(attachment_id, this.model.get('sender_duid'))+'#t=0.001" type="video/mp4"></video>'+msg_body;
            }
        } else {
            msg_body = '<p class="attachment-instructions">'+js_lang.attachment_instructions+'</p>';
            if (GP.sdata.my_user.gender == 'WOMAN') {
                msg_body += '<p class="attachment-warning">'+js_lang.attachment_warning+'</p>';
            }
            msg_body += '<div class="accept-attachments">'+
                            '<button class="btn btn-primary">'+js_lang.accept+'</button>'+
                        '</div>';
        }

        this.$el.find('.message-text').html(msg_body);
    },

    handle_audio_attachment: function() {
        var msg_body = '';
        if (this.model.get('attachment_status') == 'APPROVED' || this.model.get('direction') == 'sender') {
            var msg_id = this.model.get('msg_id');
            var attachment_id = 0;

            if (this.model.get('message')) {
                msg_body = '<br/>'+this.model.get('message');
            }
            if (msg_id < 6 * Math.pow(10,9)) {
                var self = this;
                $.post('/members/msg/get_message_attachment_id', { msg_id: msg_id }, function(data) {
                    attachment_id = data.attachment_id;
                });
            } else {
                attachment_id = msg_id;
            }

            // messages which are tagged VIDEO_ATTACHMENT should have an get_video_attachment_url generated server side now
            // but default to JS version of lib/util/api/msg.php:get_video_attachment_url() function as a fallback
            var attachment_url = this.model.get('attachment_url');

            if (attachment_url) {
                msg_body = '<audio class="audio-attachment" controls preload="metadata"><source src="'+attachment_url+'" type="audio/mp3"></audio>'+msg_body;
            } else {
                msg_body = '<audio class="audio-attachment" controls preload="metadata"><source src="'+this.get_audio_attachment_url(attachment_id, this.model.get('sender_duid'), this.model.get('attachment_ext'))+'" type="audio/'+this.model.get('attachment_ext')+'"></audio>'+msg_body;
            }
        } else {
            msg_body = '<p class="attachment-instructions">'+js_lang.attachment_instructions+'</p>';
            if (GP.sdata.my_user.gender == 'WOMAN') {
                msg_body += '<p class="attachment-warning">'+js_lang.attachment_warning+'</p>';
            }
            msg_body += '<div class="accept-attachments">'+
                            '<button class="btn btn-primary">'+js_lang.accept+'</button>'+
                        '</div>';
        }

        this.$el.find('.message-text').html(msg_body);
    },

    handle_premium_attachment: function() {
        // console.warn('handle_premium_attachment called... this.model: ', this.model);
        var msg_body = '';
        var attachment_status = this.model.get('attachment_status');
        var attachment_purchased = this.model.get('attachment_purchased');
        var direction = this.model.get('direction');

        if (attachment_status == 'APPROVED' || direction == 'sender') {
            var msg_id = this.model.get('msg_id');

            if (this.model.get('message')) {
                msg_body = '<br/>'+this.model.get('message');
            }

            var attachment_html = this.model.get('attachment_html');

            if (attachment_html) {
                msg_body = attachment_html + msg_body;
            }

        } else {
            msg_body = '<p class="attachment-instructions">'+js_lang.attachment_instructions+'</p>';
            if (GP.sdata.my_user.gender == 'WOMAN') {
                msg_body += '<p class="attachment-warning">'+js_lang.attachment_warning+'</p>';
            }
            msg_body += '<div class="accept-attachments">'+
                            '<button class="btn btn-primary">'+js_lang.accept+'</button>'+
                        '</div>';
        }

        // show correct meta info based on msg direction and attachment_purchased
        this.$el.find('.premium-attachment-info > span').addClass('hide');

        if (direction == 'recipient') {
            if (attachment_purchased) {
                this.$el.find('.premium-attachment-info .recipient-purchased').removeClass('hide');
            } else {
                this.$el.find('.premium-attachment-info .recipient').removeClass('hide');
            }
        } else {
            if (attachment_purchased) {
                this.$el.find('.premium-attachment-info .sender-purchased').removeClass('hide');
            } else {
                this.$el.find('.premium-attachment-info .sender').removeClass('hide');
            }
        }

        this.$el.find('.message-text').html(msg_body).css('white-space','normal');
    },
    trigger_purchase: function() {
        var locked_item = this.$el.find('.premium-attachment-not-purchased');
        var premium_attachment_data = {
            thread_id           : this.options.thread_id,
            premium_content_id  : $(locked_item).data('premium_content_id'),
            thumb               : $(locked_item).data('thumb'),
            type                : $(locked_item).data('type'),
            credits             : $(locked_item).data('credits'),
            msg_id              : this.model.get('msg_id'),
            duid                : this.model.get('sender_duid'),
            sender_duid         : this.model.get('sender_duid'),
            premium_attachment  : true,
        };

        // arrow functions do not have their own this context, so they capture the `this` value
        // of the enclosing context at the time they are created, so we can manipulate the model
        // and call handle_premium_attachment() using `this` like we would expect
        var success_cb = (purchase_response) => {
            // console.warn('Thread success_cb called... purchase_response: ', purchase_response);

            if (purchase_response.attachment_html) {
                this.model.set('attachment_html', purchase_response.attachment_html);
                this.model.set('attachment_purchased', purchase_response.attachment_purchased);
            }
            if (purchase_response.attachment_video) {
                this.model.set('attachment_video', purchase_response.attachment_video);
            }

            // handle premium attachment again after purchase and model update
            this.handle_premium_attachment();
        };

        GP.vent.trigger('Premium:purchase', premium_attachment_data, locked_item, success_cb);
    },

    // duplicate of lib/util/api/msg.php:msg_attachment_url() function, and is only here as a fallback
    // as msg attachment urls should be generated server side now
    get_attachment_url: function(msg_id, duid) {
        if (msg_id > _msg_min_attachment_id_node2) {
            return cdn_domain + "/content/2/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-M.jpg";
        } else if (msg_id > _msg_min_attachment_id) {
            return cdn_domain + "/content/1/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-M.jpg";
        } else if (msg_id > 6320278979) {
            return "//contentcdn.fling.com/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-M.jpg";
        } else {
            return "//contentcdn.fling.com/mp/"+(parseInt(parseInt(msg_id,10)/10000,10))+"/"+msg_id+"-"+duid+"-M.jpg";
        }
    },
    get_video_attachment_url: function(msg_id, duid) {
        if (msg_id > _msg_min_attachment_id_node2) {
            return cdn_domain_videos + "/content/2/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-HD.mp4";
        } else if (msg_id > _msg_min_attachment_id) {
            return cdn_domain_videos + "/content/1/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-HD.mp4";
        } else if (msg_id > 6320278979) {
            return "//contentcdn.fling.com/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"-HD.mp4";
        } else {
            return "//contentcdn.fling.com/mp/"+(parseInt(parseInt(msg_id,10)/10000,10))+"/"+msg_id+"-"+duid+"-HD.mp4";
        }
    },
    get_audio_attachment_url: function(msg_id, duid, ext) {
        if (msg_id > _msg_min_attachment_id_node2) {
            return cdn_domain + "/content/2/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"."+ext;
        } else if (msg_id > _msg_min_attachment_id) {
            return cdn_domain + "/content/1/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"."+ext;
        } else if (msg_id > 6320278979) {
            return "//contentcdn.fling.com/mp2/"+(parseInt(parseInt(msg_id,10)/10000000,10))+"/"+msg_id+"-"+duid+"."+ext;
        } else {
            return "//contentcdn.fling.com/mp/"+(parseInt(parseInt(msg_id,10)/10000,10))+"/"+msg_id+"-"+duid+"."+ext;
        }
    },
    handle_media_approved: function(e) {
        var href = $(e.currentTarget).attr('href');
        if (href.length && href.indexOf('media.picture') !== -1) {
            e.preventDefault();
            e.stopPropagation();
            if (MoshPit.get_size() != 'mobile') {
                GP.vent.trigger('ThreadLayout:minimize', { full_minimize: true });
            } else {
                GP.vent.trigger('ThreadLayout:close');
            }
            var pic_url = '/members/media/picture/?duid=' + GP.sdata.my_user.duid + '&type=profile';
            GP.vent.trigger('Modal:open', { href: pic_url });
        } else if (href.length && href.indexOf('media.video') !== -1) {
            e.preventDefault();
            e.stopPropagation();
            if (MoshPit.get_size() != 'mobile') {
                GP.vent.trigger('ThreadLayout:minimize', { full_minimize: true });
            } else {
                GP.vent.trigger('ThreadLayout:close');
            }
            var video_url = '/members/media/video/?duid=' + GP.sdata.my_user.duid + '&type=profile';
            GP.vent.trigger('Modal:open', { href: video_url });
        }
    },
    del_rude_user_msg: function() {
        this.model.destroy();
    },
    approve_private_content: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':handle_private_request', 'APPROVED');
        this.model.destroy();
    },
    deny_private_content: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':handle_private_request', 'DENIED');
        this.model.destroy();
    },
    rate_user: function(e) {
        var self = this;

        e.preventDefault();
        e.stopPropagation();

        var $clicked_btn = $(e.currentTarget);
        var rate_duid    = this.options.model.get('duid');

        $.post('/members/user/hot_or_not/', {
            'duid': rate_duid,
            'rating': 'LIKE',
            'add_rating': 1
        }, function(json_response) {
            // console.log('rate_user json_response: ', json_response);

            // unlock thread for mutual matches
            if (json_response.hasOwnProperty('mutual_match') && json_response.mutual_match === true) {
                // unlock thread by displaying reply inputs and private videochat buttons etc...
                $('#thread-' + self.options.thread_id).removeClass('noreply hide-private-vc');

                // display notification to user
                var msg = 'You two have a mutal match!  Chat with them.';
                GP.vent.trigger('ThreadLayout.thread-'+self.options.thread_id+':show_notification', 'success', msg);

                // get rid of special msg_id 5 with the locked thread msg/button
                self.model.destroy();

                return;
            }

            // disable the btn at least?
            $clicked_btn.attr('disabled', true);
        });
    },
    trigger_msg_priority: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':toggle_priority');
        // this.model.destroy();
    },
    trigger_sent_msg_priority: function() {
        GP.vent.trigger('MessagePane.Thread:set_sent_msg_priority', this.options);
    },
    show_sent_via: function() {
        var mpf_tags = ['MSG_PREF_AGE_RANGE','MSG_PREF_PICS_ONLY','MSG_PREF_LOCAL_ONLY'];

        if (_.contains(this.model.get('tag'), 'WYWA')) {
            this.$el.find('.sent-via.wywa .qm').popover({
                html: true,
                trigger: 'click',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.wywa_explanation;
                }
            });
            this.$el.find('.sent-via.wywa').show();
        } else if (this.model.get('direction') == 'recipient' && _.intersection(mpf_tags, this.model.get('tag')).length > 0) {
            this.$el.find('.sent-via.mpf .qm').popover({
                html: true,
                trigger: 'click',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.mpf_explanation;
                }
            });
            this.$el.find('.sent-via.mpf').show();
        } else if (this.model.get('direction') == 'recipient' && _.intersection(['ICE_BREAKER'], this.model.get('tag')).length > 0) {

            this.$el.find('.sent-via.ice-breaker .qm').popover({
                html: true,
                trigger: 'click',
                placement: 'bottom',
                sanitize: false,
                content: function() {
                    return js_lang.ice_breaker_explanation;
                }
            });
            this.$el.find('.sent-via.ice-breaker').show();
        } else if (_.contains(this.model.get('tag'), 'MOBILE')) {
            this.$el.find('.sent-via.mobile').show();
        } else {
            this.$el.find('.sent-via.web').show();
        }
    },
    handle_msg_options: function(e) {
        e.preventDefault();
        let msg_data = { msgId: this.model.get('msg_id') };
        let cm_input = { template: 'DEL_MSG'};
        let that = this;

        vent.trigger('Modal:open:confirm', cm_input, function() {
            $.post("/app/members/msg/del_msg", msg_data

            ).done(function (json) {
                if (json && json.errors) {
                    that.show_alert_error(json.errors);
                } else {
                    // update client side message with deleted text
                    GP.vent.trigger('MessagePane.Thread:mod_thread_msg', {
                        msg_id : msg_data.msgId,
                        thread_id: that.options.thread_id,
                        message: js_lang.msg_deleted,
                        tag: 'DELETED'
                    });

                    // remove priority message notice
                    GP.vent.trigger('MessagePane.Thread:remove_priority_msg_item', { thread_id: that.options.thread_id });
                }
            })
            .fail(function(xhr, status, error) {
                if (xhr.responseJSON.errors.length) {
                    that.show_alert_error(xhr.responseJSON.errors);
                }
            }).always(function () {

            });
        });
    },
    show_alert_error: function(errors) {
        let alert_input = {
            template: 'ERROR',
            sprintf: ''
        };

        for (i = 0; i < errors.length; i++) {
            alert_input.sprintf +=  errors[i] + '<br>';
        }
        vent.trigger('Modal:open:alert', alert_input);        
    },
    handle_reactions: function() {
        let reactions_wrap = this.$el.find('.reactions-wrap')[0];
        htmx.ajax('GET', '/fragment/popovers/msg_reactions', {
            target: reactions_wrap,
            values: {
                msgId: this.model.get('msg_id'),
                threadId: this.options.thread_id
            }
        });
    },
    emoji_change: function() {
        this.$el.addClass('animate');
    }
});

GP.views.MessagesList = Backbone.Marionette.CollectionView.extend({
    tagName: 'ul',
    className: 'messages-list',
    childView: GP.views.MessagesListItem,
    onBeforeAddChild: function(childView) {
        // the only way to pass data to a childView...
        childView.options.thread_id = this.options.thread_id;
    },
    onShow: function() {
        // TODO: there should be a way to do this without setTimeout
        let thread_id = this.options.thread_id;
        let open_to_msg_id = this.options.open_to_msg_id || null;

        setTimeout(function() {
            GP.vent.trigger('ThreadLayout.thread-'+thread_id+':messages_loaded', open_to_msg_id);
        }, 350);
    },
    onDomRefresh: function() {
        GP.vent.trigger('ThreadLayout.thread-'+this.options.thread_id+':dom_refresh');
    }
});

